import { render } from "./MoveContent.vue?vue&type=template&id=405d8591&scoped=true"
import script from "./MoveContent.vue?vue&type=script&lang=js"
export * from "./MoveContent.vue?vue&type=script&lang=js"

import "./MoveContent.vue?vue&type=style&index=0&id=405d8591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405d8591"]])

export default __exports__